<app-main-content-card>
  <div
    class="title-bar baseline"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <button mat-button class="me-3" (click)="backButtonClicked()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1 class="my-0">{{ "VIP_DISCOUNTS.TITLE" | translate }}</h1>
    </div>

    <button
      mat-raised-button
      color="primary"
      (click)="toInvalid.scrollToFirstInvalidControl(); onSave()"
    >
      {{ "SHARED.SAVE" | translate }}
    </button>
  </div>

  <div class="d-flex justify-content-between align-items-end my-4">
    <form class="easy-form" [formGroup]="form">
      <mat-form-field>
        <app-easy-input
          formControlName="discountValue"
          type="number"
          [label]="
            'VIP_DISCOUNTS.SETTINGS.' +
              (form.get('discountMode')?.value === 'PERCENT'
                ? 'REDUCE_BY_PERCENT'
                : 'REDUCE_BY_AMOUNT') | translate
          "
          [hideRequiredLabel]="true"
          [min]="0"
          [max]="
            form.get('discountMode')?.value === 'PERCENT' ? 100 : undefined
          "
          [maxDecimals]="2"
        ></app-easy-input>
      </mat-form-field>
      <mat-form-field>
        <app-easy-select
          formControlName="discountMode"
          [options]="discountModeOptions"
          [labelAttribute]="'label'"
          [valueAttribute]="'value'"
          [hasEmptyOption]="false"
          (ngModelChange)="discountModeChanged()"
        ></app-easy-select>
      </mat-form-field>
      <mat-form-field>
        <label for="vipStartDate">{{
          "VIP_DISCOUNTS.SETTINGS.DATE_FROM" | translate
        }}</label>
        <div class="form-field-container date-field">
          <input
            id="vipStartDate"
            formControlName="startDate"
            [matDatepicker]="pickerFrom"
            class="suffix"
            matInput
            (focus)="pickerFrom.open()"
          />
          <span matSuffix (click)="pickerFrom.open()">
            <mat-icon>today</mat-icon>
          </span>
          <mat-datepicker #pickerFrom></mat-datepicker>
        </div>
      </mat-form-field>
      <mat-form-field>
        <label for="vipEndDate">{{
          "VIP_DISCOUNTS.SETTINGS.DATE_TO" | translate
        }}</label>
        <div class="form-field-container date-field">
          <input
            id="vipEndDate"
            formControlName="endDate"
            [matDatepicker]="pickerTo"
            class="suffix"
            matInput
            [min]="
              form.get('startDate')?.value
                ? form.get('startDate')?.value
                : today
            "
            (focus)="pickerTo.open()"
          />
          <span matSuffix (click)="pickerTo.open()">
            <mat-icon>today</mat-icon>
          </span>
          <mat-datepicker #pickerTo></mat-datepicker>
        </div>
      </mat-form-field>
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="applyGroupDiscount()"
        class="apply-btn"
      >
        {{ "SHARED.APPLY" | translate }}
      </button>
    </form>
    <button
      mat-stroked-button
      color="primary"
      class="ms-4"
      type="button"
      [disabled]="(isAllMerchantsSelected$ | async) === 'NOT_CHECKED'"
      (click)="deleteSelectedItems()"
    >
      {{ "VIP_DISCOUNTS.SETTINGS.DELETE_SELECTED_ITEMS" | translate }}
    </button>
  </div>

  <div
    fxLayout="column"
    fxLayoutGap="15px"
    appScrollToInvalidControl
    #toInvalid="appScrollToInvalidControl"
  >
    <app-vip-discounts-settings-table
      *ngFor="
        let discount of discountToMerchantList$ | async;
        let i = index;
        trackBy: trackDiscount
      "
      [discountToMerchant]="discount"
      [showCaptionRow]="i === 0"
      [tableIndex]="i"
    ></app-vip-discounts-settings-table>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center">
    <button
      mat-raised-button
      color="primary"
      (click)="toInvalid.scrollToFirstInvalidControl(); onSave()"
    >
      {{ "SHARED.SAVE" | translate }}
    </button>
  </div>
</app-main-content-card>
